import * as React from 'react';
import { useEffect } from 'react';
import { useRouteData, useRoutePath } from 'react-static';
import { IS_SERVER } from '../../common/constants';
import { pushToDataLayer } from '../../common/helpers/dataLayer';
import { windowLocationHash } from '../../common/helpers/window';
import { useDebug } from '../../common/hooks/useDebug';
import { Card } from '../../components/card/Card';
import { FeaturedBanner } from '../../components/featured-banner/FeaturedBanner';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { Subnav } from '../../components/subnav/Subnav';
import { DefaultLayout } from '../default/DefaultLayout';
import { CompanyCardsProps, CompanyLayoutProps, CompanyPageDetailData } from './CompanyLayout.props';
import { StyledCompanyCards, StyledCompanyLayout } from './CompanyLayout.styles';

const CompanyCards = ({ data, headingTag }: CompanyCardsProps) => {
  if (!(data || []).length) {
    return null;
  }

  return (
    <StyledCompanyCards>
      {!IS_SERVER &&
        data.map(({ anchor, biography, image, position, title }: CompanyPageDetailData, index: number) => {
          const expandProfileDetails = !!anchor && anchor === windowLocationHash();
          const cardTitle = {
            title,
            subtitle: position,
          };

          // We avoid rendering on the server-side, so that the anchor will correctly expand on a full page reload
          return (
            <Card
              anchor={anchor}
              cardTitle={cardTitle}
              details={biography}
              headingTag={headingTag}
              initialIsContentExpanded={expandProfileDetails}
              image={image}
              key={`${title}-${index}`}
            />
          );
        })}
    </StyledCompanyCards>
  );
};

// noinspection JSUnusedGlobalSymbols
export default () => {
  const { companyProps } = useRouteData<CompanyLayoutProps>();
  const path = useRoutePath('');

  const dropdownPlaceholder = companyProps.type === 'leadership' ? 'Executives' : 'Divisions';
  const title = `${companyProps.title} | Company`;

  useDebug('app:layout:CompanyLayout', { props: { companyProps } });

  useEffect(() => {
    pushToDataLayer({
      contentType: companyProps.type,
      title: `${companyProps.title} : ${windowLocationHash()}`,
    });
  }, []);

  const breadcrumbs = [{ text: companyProps.title, url: path }];

  return (
    <DefaultLayout locale='en-US' seo={companyProps.seo}>
      <HeadTitle title={title} />
      <StyledCompanyLayout>
        <FeaturedBanner {...companyProps.banner} />
        {companyProps.categories && (
          <Subnav
            breadcrumbs={breadcrumbs}
            currentPage={companyProps.currentPage}
            data={companyProps.categories}
            dropDown={true}
            dropdownPlaceholder={dropdownPlaceholder}
            hash={windowLocationHash()}
            title={companyProps.title}
          />
        )}
        <CompanyCards data={companyProps.data} headingTag='h1' />
      </StyledCompanyLayout>
    </DefaultLayout>
  );
};
